import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Swal from "sweetalert2";

import IncumbenciasFetcher from "./IncumbenciasFetcher";
import IncumbenciasSelector from "./IncumbenciasSelector";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";

const GestorIncumbenciasDocentes = ({ dniConstante }) => {
  const [schoolName, setSchoolName] = useState("escuela de policia");
  const [incumbenciasDocente, setIncumbenciasDocente] = useState([]);
  const [incumbenciasEscuela, setIncumbenciasEscuela] = useState([]);
  const [selected, setSelected] = useState([]);

  // 🔹 Usuario cargado correctamente SIN necesidad de refrescar
  const [usuario, setUsuario] = useState(null);

  useEffect(() => {
    const u = ObtieneDatosCookies();
    setUsuario(u);
  }, []);

  // 1️⃣ Traer incumbencias del docente
  useEffect(() => {
    if (!dniConstante || dniConstante.toString().length < 5) return;

    const controller = new AbortController();

    const fetchDocente = async () => {
      try {
        const response = await axios.post(
          `https://wwwa.isepsantafe.net.ar/expedientes/docentes/getIncumbenciasPorDni/${dniConstante}`,
          {},
          { signal: controller.signal }
        );
        setIncumbenciasDocente(response.data.incumbencias || []);
      } catch (err) {
        console.error("Error al traer incumbencias del docente:", err);
        setIncumbenciasDocente([]);
      }
    };

    fetchDocente();
    return () => controller.abort();
  }, [dniConstante]);

  // 2️⃣ Traer incumbencias por escuela
  const handleFetchEscuela = useCallback((data) => {
    setIncumbenciasEscuela(data);
  }, []);

  // 3️⃣ Filtrar las materias que coincidan con las del docente
  useEffect(() => {
    if (incumbenciasDocente.length === 0 || incumbenciasEscuela.length === 0) {
      setSelected([]);
      return;
    }

    const docentesIds = new Set(incumbenciasDocente.map((inc) => inc.id));
    const coincidencias = incumbenciasEscuela.filter((inc) =>
      docentesIds.has(inc.id)
    );

    setSelected(coincidencias.map((inc) => inc.nombreMateria));
  }, [incumbenciasDocente, incumbenciasEscuela]);

  // Manejar selección manual
  const handleSelect = useCallback((materias) => {
    setSelected(materias);
  }, []);

  // 4️⃣ Función para enviar actualizaciones a la API con SweetAlert
  const handleEnviar = async () => {
    try {
      if (!usuario?.id) {
        Swal.fire("Error", "No se pudo obtener el usuario.", "error");
        return;
      }

      const allIds = incumbenciasEscuela.map((inc) => inc.id);
      const selectedIds = incumbenciasEscuela
        .filter((inc) => selected.includes(inc.nombreMateria))
        .map((inc) => inc.id);

      const desactivar = allIds.filter((id) => !selectedIds.includes(id));
      const originalIds = incumbenciasDocente.map((inc) => inc.id);

      const agregadas = selectedIds.filter((id) => !originalIds.includes(id));
      const quitadas = desactivar.filter((id) => originalIds.includes(id));

      const agregadasNombres = incumbenciasEscuela
        .filter((inc) => agregadas.includes(inc.id))
        .map((inc) => inc.nombreMateria);

      const quitadasNombres = incumbenciasEscuela
        .filter((inc) => quitadas.includes(inc.id))
        .map((inc) => inc.nombreMateria);

      const payload = {
        docenteDni: dniConstante.toString(),
        competencias: selectedIds,
        usuarioID: usuario.identificacion,
        desactivar,
      };

//       console.log(payload);

      await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/docentes/actualizarIncumbenciasDocente",
        payload
      );

      Swal.fire({
        title: "Actualización exitosa",
        html: `
          ${agregadasNombres.length > 0 ? `<p><b>Agregadas:</b> ${agregadasNombres.join(", ")}</p>` : ""}
          ${quitadasNombres.length > 0 ? `<p><b>Quitadas:</b> ${quitadasNombres.join(", ")}</p>` : ""}
          ${agregadasNombres.length === 0 && quitadasNombres.length === 0 ? `<p>No hubo cambios</p>` : ""}
        `,
        icon: "success",
        timer: 10000,
        timerProgressBar: true,
        showConfirmButton: true,
        confirmButtonText: "Aceptar",
      });
    } catch (error) {
      console.error("Error al enviar actualizaciones:", error);
      Swal.fire({
        title: "Error",
        text: "No se pudieron actualizar las incumbencias.",
        icon: "error",
        timer: 10000,
        timerProgressBar: true,
        showConfirmButton: true,
        confirmButtonText: "Aceptar",
      });
    }
  };

  return (
    <div className="p-4 space-y-4">
      <IncumbenciasFetcher schoolName={"Todas"} onFetch={handleFetchEscuela} />

      <IncumbenciasSelector
        incumbencias={incumbenciasEscuela}
        selected={selected}
        onSelect={handleSelect}
      />

      <button onClick={handleEnviar} className="btn btn-success mt-2">
        Enviar Actualizaciones
      </button>
    </div>
  );
};

export default GestorIncumbenciasDocentes;
